// Toda a matemática de "desconsiderar" fica centralizada aqui — é usada tanto pelo
// ApuracaoPanel1 (pra mostrar o card já ajustado) quanto pelo Apuracao.js (pra montar
// os _fin do backend e pra recalcular os painéis de resumo). Um lugar só pra mudar a regra.

export const formatBRL = (num) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(num || 0);

// "desconsiderar" sempre aproxima o valor de zero: se o original é negativo (faltas), soma;
// se é positivo (sobras), subtrai.
export const aplicarDesconto = (valor, desconto) => {
    valor = valor || 0;
    desconto = desconto || 0;
    return valor >= 0 ? valor - desconto : valor + desconto;
};

// valores finais de um grupo (faltas/sobras) depois de aplicado o ajuste — sem ajuste, sai igual ao original
export const finalGrupo = (grupo, ajuste) => ({
    faltasValor: aplicarDesconto(grupo?.faltas?.valor, ajuste?.faltasValor),
    faltasItens: (grupo?.faltas?.itens || 0) - (ajuste?.faltasItens || 0),
    sobrasValor: aplicarDesconto(grupo?.sobras?.valor, ajuste?.sobrasValor),
    sobrasItens: (grupo?.sobras?.itens || 0) - (ajuste?.sobrasItens || 0),
});

// os 4 campos _fin que o backend espera pra um grupo, mais a justificativa
export const gerarFin = (grupo, ajuste) => {
    let f = finalGrupo(grupo, ajuste);
    return {
        faltQtdFin: f.faltasItens,
        faltVlrFin: f.faltasValor,
        sobrQtdFin: f.sobrasItens,
        sobrVlrFin: f.sobrasValor,
        justificativa: ajuste?.justificativa || null,
    };
};

// recalcula ApuracaoPanel3 (diferenças) e ApuracaoItensAjustados a partir do principal/fornecedor + ajustes.
//
// Formato de saída PLANO (números crus, não string formatada) — é exatamente o que o backend
// manda em apuracao.diferencas / apuracao.itensAjustados, e o que os componentes esperam
// (eles mesmos chamam .toLocaleString(...) em cima do número).
//
// Regra confirmada no backend (ApuracaoController::buscar):
//   - diferenca    = só o grupo PRINCIPAL (faltas + sobras)
//   - divergencia  = só o grupo FORNECEDOR (faltas + sobras)
//   - total        = diferenca + divergencia
//   - itensAjustados = só o grupo PRINCIPAL (avaria/manuais/semanais NÃO entram)
export function calcularDerivados(apuracao, ajustes = {}) {
    let principal = finalGrupo(apuracao?.principal, ajustes.principal);
    let avaria = finalGrupo(apuracao?.avaria, ajustes.avaria);
    let fornecedor = finalGrupo(apuracao?.ajustesFornecedor, ajustes.ajustesFornecedor);
    let ajustesManuais = finalGrupo(apuracao?.ajustesManuais, ajustes.ajustesManuais);
    let ajustesSemanais = finalGrupo(apuracao?.ajustesSemanais, ajustes.ajustesSemanais);

    let diferenca = round2(
        principal.faltasValor + principal.sobrasValor +
        avaria.faltasValor + avaria.sobrasValor +
        ajustesManuais.faltasValor + ajustesManuais.sobrasValor +
        ajustesSemanais.faltasValor + ajustesSemanais.sobrasValor +
        apuracao.nf
    );
    let divergencia = round2(fornecedor.faltasValor + fornecedor.sobrasValor);
    let total = round2(diferenca + divergencia);
    let meta = apuracao?.diferencas?.meta; // meta continua vindo do backend (snapshot da época)

    let diferencas = {
        diferenca,
        divergencia,
        total,
        totalPositivo: total > 0,
        meta,
        atingida: meta != null ? Math.abs(diferenca) <= meta : undefined,
    };

    let itensFalta = principal.faltasItens + ajustesManuais.faltasItens + ajustesSemanais.faltasItens;
    let itensSobra = principal.sobrasItens + ajustesManuais.sobrasItens + ajustesSemanais.sobrasItens;
    let itensTotal = itensFalta + itensSobra;
    let metaTotal = apuracao?.itensAjustados?.metaTotal; // meta continua vindo do backend

    let itensAjustados = {
        itensFalta,
        itensSobra,
        itensTotal,
        metaTotal,
        acimaMeta: metaTotal != null ? itensTotal > metaTotal : undefined,
    };

    return { itensAjustados, diferencas };
}

const round2 = (num) => Math.round((num + Number.EPSILON) * 100) / 100;
